export const ADMIN_ROUTE = 'admin-e7f9a3d2b1c0';
